import { Button, Card, Conditional } from '@payaca/ambrosia';

import { FC, PropsWithChildren } from 'react';

export interface IProps {
  disabled?: boolean;
  onRemove?: () => void;
}

const FieldSetArrayInnerCard: FC<PropsWithChildren<IProps>> = (props) => {
  const { children, onRemove } = props;

  return (
    <Card>
      <Card.Body className="space-y-4">
        {children}

        <Conditional condition={!!onRemove}>
          <Button onClick={onRemove} variant="link">
            Remove
          </Button>
        </Conditional>
      </Card.Body>
    </Card>
  );
};

export default FieldSetArrayInnerCard;
